import Model from '@/models/Model.js';

export default class LocationGroup extends Model {
    static entity = 'location_groups';

    static modelName = 'LocationGroup';

    static fields() {
        return {
            id: this.attr(null),
            location_id: this.attr(null),
            group_id: this.attr(null),

            ...super.fields(),

            location: this.belongsTo('locations', 'location_id'),
            group: this.belongsTo('groups', 'group_id'),
        };
    }
}
